import styled from "styled-components";

export const Card = styled.div`
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 16px;
  display: flex;
 
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06);
`;

export const CheckBoxArea = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;

  p {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 0.4rem;
  }
`;
